/* BulkReassign — /admin/bulk-reassign
 * Superadmin-only section to bulk-reassign tasks across users with filters.
 */
import css from '../AdminPage.module.css';
import BulkReassignPanel from '../../../components/BulkReassignPanel';

export default function BulkReassign() {
  return (
    <div className={css.section}>
      <div className={css.sectionHeader}>
        <h1 className={css.sectionTitle}>Bulk Reassign Tasks</h1>
        <p className={css.sectionSubtitle}>
          Reassign one user&rsquo;s tasks to one or more other users, with optional filters. Use
          &ldquo;Preview matches&rdquo; to confirm scope before applying.
        </p>
      </div>
      <BulkReassignPanel />
    </div>
  );
}
